import React, { useEffect, useState } from 'react'

import { DEFAULT_LANG } from 'config/languages'
import trackEvent from 'utils/trackEvent'
import Button from 'components/elements/Button'
import FontAwesome from 'components/FontAwesome'
import Markdown from 'components/Markdown'
import SmallText from 'components/SmallText'
import Emblem from 'assets/svg/emblem.svg'

import PostHeader from './PostHeader'
import Cover from './Cover'
import {
   StyledArticle,
   PDFWrapper,
   StyledContent,
   StyledDivider,
   StyledNextArticle,
   StyledSocialsWrapper,
   StyledNewsletterFormContainer,
   StyledNewsletterFormTitle,
   StyledEmblem,
} from './styles'
import PostThumbnail from '../../../components/PostThumbnail'
import { CopySocialButton, TwitterSocialButton, EmailSocialButton, TelegramSocialButton } from 'components/elements/SocialButton/SocialButton'
import { parseLocalDate } from '../../../utils/helpers'
import NewsletterForm from 'components/elements/NewsletterForm'

export default function PostData({ data, additionalData, nextPost, lang, path }) {
   const langPrefix = lang === DEFAULT_LANG ? '/' : `/${lang}/`
   const [animationStart, setAnimationStart] = useState(false)
   const { postTitle, postCategories, postContent, timeRead, postDate, postAuthors, pdf, cover, disableTextBalance } = data
   const { authorLabel, disclosures, downloadLabel } = additionalData
   useEffect(() => {
      setAnimationStart(true)
   }, [])

   return (
      <StyledArticle pose={animationStart ? 'open' : 'exit'}>
         <PostHeader
            title={postTitle}
            timeRead={timeRead}
            date={postDate}
            categories={postCategories}
            authors={postAuthors}
            langPrefix={langPrefix}
            lang={lang}
            authorLabel={authorLabel}
            disableTextBalance={disableTextBalance}
         />
         <div></div>
         <StyledSocialsWrapper>
            <EmailSocialButton title={postTitle} />
            <TelegramSocialButton title={postTitle} />
            <TwitterSocialButton title={postTitle} />
            <CopySocialButton postUrl={path} />
         </StyledSocialsWrapper>
         <StyledDivider />
         {cover && <Cover {...cover} />}
         {pdf?.file && (
            <div>
               <PDFWrapper>
                  <Button
                     onClick={() => {
                        trackEvent('Download PDF Clicked', postTitle)
                     }}
                     variant="dark"
                  >
                     <a href={`https:${pdf.file.url}`} target="_blank" rel="noreferrer">
                        <span>{downloadLabel}</span>
                        <FontAwesome icon={'arrowRight'} />
                     </a>
                  </Button>
               </PDFWrapper>
            </div>
         )}
         {postContent?.markdown && (
            <StyledContent>
               <Markdown lang={lang}>{postContent.markdown}</Markdown>
            </StyledContent>
         )}
         <StyledNewsletterFormContainer>
            <StyledEmblem src={Emblem} alt="Emblem" />
            <StyledNewsletterFormTitle>Stay up to date</StyledNewsletterFormTitle>
            <NewsletterForm placeholder="Sign up for our newsletter" />
         </StyledNewsletterFormContainer>
         <StyledNextArticle>Next Article</StyledNextArticle>
         {nextPost && (
            <PostThumbnail
               postTitle={nextPost.title}
               slug={nextPost.slug}
               postCategories={nextPost.categories.map((cat) => ({
                  categoryName: cat.categoryName,
                  categoryLabel: cat.categoryName,
               }))}
               postDate={parseLocalDate(nextPost.date, nextPost.node_locale)}
               postExcerpt={{ text: nextPost.description }}
               timeRead={nextPost.timeRead}
               postAuthors={nextPost.authors}
            />
         )}
         {disclosures?.markdown && (
            <div>
               <SmallText content={disclosures.markdown} />
            </div>
         )}
      </StyledArticle>
   )
}
